import React from 'react';
import { Box, Typography } from '@mui/material';
import MonthYearSelector from '../MonthYearSelector';
import SectionHeader from '../SectionHeader';

interface PayrollSummary {
  totalEmployees: number;
  totalGrossSalary: number;
  totalNetSalary: number;
  totalTax: number;
  totalInsurance: number;
}

interface PayrollToolbarProps {
  selectedMonth: Date;
  onMonthChange: (date: Date) => void;
  payrollSummary: PayrollSummary;
}

export const PayrollToolbar: React.FC<PayrollToolbarProps> = ({
  selectedMonth,
  onMonthChange,
  payrollSummary,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: 2,
      mb: 2,
      p: 2,
      background: 'var(--bg-elev-2)',
      borderRadius: 1,
      border: '1px solid var(--border-default)',
    }}
  >
    <Box sx={{ minWidth: 0 }}>
      <SectionHeader
        eyebrow="급여"
        title="급여 관리"
        subtitle={`${selectedMonth.toLocaleDateString('ko-KR', { year: 'numeric', month: 'long' })} 급여 계산`}
      />
    </Box>
    <Box sx={{ transform: 'scale(0.9)', transformOrigin: 'center' }}>
      <MonthYearSelector selectedDate={selectedMonth} onDateChange={onMonthChange} />
    </Box>
    <Box sx={{ display: 'flex', gap: 3, ml: 'auto', alignItems: 'center', flexWrap: 'wrap' }}>
      <Typography sx={{ fontSize: 17, color: 'var(--fg-secondary)' }}>
        총 직원: <Box component="strong" sx={{ fontSize: 19, fontWeight: 700, color: 'var(--fg-strong)' }}>{payrollSummary.totalEmployees}명</Box>
      </Typography>
      <Typography sx={{ fontSize: 17, color: 'var(--fg-secondary)' }}>
        총 급여:{' '}
        <Box component="strong" sx={{ fontFamily: 'var(--font-mono)', fontVariantNumeric: 'tabular-nums', fontSize: 19, fontWeight: 700, color: 'var(--fg-strong)' }}>
          {payrollSummary.totalGrossSalary.toLocaleString()}
        </Box>
      </Typography>
      <Typography sx={{ fontSize: 15, color: 'var(--fg-tertiary)' }}>
        총 세금:{' '}
        <Box component="span" sx={{ fontFamily: 'var(--font-mono)', fontVariantNumeric: 'tabular-nums' }}>
          {payrollSummary.totalTax.toLocaleString()}
        </Box>
      </Typography>
      <Typography sx={{ fontSize: 17, color: 'var(--primary-press)' }}>
        실수령액:{' '}
        <Box component="strong" sx={{ fontFamily: 'var(--font-mono)', fontVariantNumeric: 'tabular-nums', fontSize: 22, fontWeight: 800, color: 'var(--primary)' }}>
          {payrollSummary.totalNetSalary.toLocaleString()}
        </Box>
      </Typography>
    </Box>
  </Box>
);
